import Vue from 'vue'
import Vuex from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { state } from './state'
import { mutations } from './mutations'
import surveyModule from './modules/survey'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    survey: surveyModule
  },
  state,
  getters,
  actions,
  mutations
})
